import {
  disabledFalse,
  disabledTrue,
  hiddenFilter,
  PORTFOLIOS,
  ROLES,
} from "../../constants";
import { parseSpanishPrice } from "../../helpers/numbersHelpers";

const isSuperAdmin = () => {
  const userRoles = JSON.parse(localStorage.getItem("userRoles"));
  return !!userRoles.some((rol) => rol.name === ROLES.SUPERADMIN);
};

const notPermissionFieldsForm = () => {
  const userRoles = JSON.parse(localStorage.getItem("userRoles"));
  return !userRoles.some(
    (rol) =>
      rol.name === ROLES.ADMIN ||
      rol.name === ROLES.SUPERADMIN ||
      rol.name === ROLES.PARTICULAR
  );
};

/**
 *
 * Validate whether the field is mandatory for the business line set in the <b>requiredBusinessLines</b> parameter.
 *
 * @param {*} requiredBusinessLines
 * @param {*} assetBusinessLine
 * @returns
 */
const isRequiredForLineBusiness = (
  requiredBusinessLines,
  assetBusinessLine
) => {
  return requiredBusinessLines.includes(assetBusinessLine);
};
export const buildFormDataEditParticularAsset = (data) => {
  let formData = {};
  //Datos Generales
  formData.id = data.id;
  formData.businessLine = bl[data.businessLine];

  //Particulares
  if (data.okPBC === "true" || data.okPBC === true) {
    formData.okPBC = true;
  } else if (data.okPBC === "false" || data.okPBC === false) {
    formData.okPBC = false;
  } else {
    formData.okPBC = null;
  }
  if (data.okRegistral === "true" || data.okRegistral === true) {
    formData.okRegistral = true;
  } else if (data.okRegistral === "false" || data.okRegistral === false) {
    formData.okRegistral = false;
  } else {
    formData.okRegistral = null;
  }
  if (!!data.mandateDateSign) {
    const array = data.mandateDateSign.split("T");
    formData.mandateDateSign = !!array[1]
      ? `${array[0]}T${array[1]}Z`
      : `${array[0]}T00:00:00.000Z`;
  } else {
    formData.mandateDateSign = null;
  }
  if (!!data.mandateModality) {
    formData.mandateModality = data.mandateModality;
  } else {
    formData.mandateModality = null;
  }
  if (!!data.mandateDuration) {
    formData.mandateDuration = parseInt(data.mandateDuration);
  } else {
    formData.mandateDuration = null;
  }
  if (
    data.isBrandNewConstruction === "true" ||
    data.isBrandNewConstruction === true
  ) {
    formData.isBrandNewConstruction = true;
  } else if (
    data.isBrandNewConstruction === "false" ||
    data.isBrandNewConstruction === false
  ) {
    formData.isBrandNewConstruction = false;
  } else {
    formData.isBrandNewConstruction = null;
  } 

  //Localizacion
  if (!!data.typeOfRoad) {
    formData.typeOfRoad = data.typeOfRoad;
  } else {
    formData.typeOfRoad = "AVENIDA";
  }
  formData.road = data.road;
  formData.number = data.number;
  if (!!data.floor) {
    formData.floor = data.floor;
  }
  if (!!data.door) {
    formData.door = data.door;
  }
  if (!!data.stair) {
    formData.stair = data.stair;
  } else {
    formData.stair = null;
  }

  if (!!data.block) {
    formData.block = data.block;
  } else {
    formData.block = null;
  }
  formData.postalCode = data.postalCode;
  formData.municipalityId = data.municipalityId;
  if (!!data.latitude) {
    formData.latitude = data.latitude.toString().replace(",", ".");
  } else {
    formData.latitude = null;
  }
  if (!!data.longitude) {
    formData.longitude = data.longitude.toString().replace(",", ".");
  } else {
    formData.longitude = null;
  }
  if (!!data.district) {
    formData.district = data.district;
  } else {
    formData.district = null;
  }
  formData.hideNumber = data.hideNumber;
  formData.hideAddress = data.hideAddress;
  if (!!data.commuterTrain) {
    formData.commuterTrain = data.commuterTrain;
  } else {
    formData.commuterTrain = data.commuterTrain;
  }
  if (!!data.bus) {
    formData.bus = data.bus;
  } else {
    formData.bus = null;
  }
  if (!!data.highway) {
    formData.highway = data.highway;
  } else {
    formData.highway = null;
  }

  //Características del inmueble
  if (!!data.description) {
    formData.description = data.description;
  } else {
    formData.description = null;
  }
  if (!!data.descriptionEN) {
    formData.descriptionEN = data.descriptionEN;
  } else {
    formData.descriptionEN = null;
  }
  if (!!data.descriptionFR) {
    formData.descriptionFR = data.descriptionFR;
  } else {
    formData.descriptionFR = null;
  }
  formData.delegationId = data.delegationId;
  formData.commercialNetType = parseInt(data.commercialNetType);
  formData.subTypeId = data.subTypeId;
  if (!!data.crmPrice || data.crmPrice === 0) {
    if (data.crmPrice !== 0) {
      formData.crmPrice = parseSpanishPrice(data.crmPrice);
    } else {
      formData.crmPrice = 0;
    }
  } else {
    formData.crmPrice = null;
  }
  formData.bathrooms = parseInt(data.bathrooms);
  formData.bedrooms = parseInt(data.bedrooms);
  formData.builtM2 = data.builtM2.split(".").join(",");
  formData.builtInWardrobe = data.builtInWardrobe;

  if (data.hasStorage === "true" || data.hasStorage === true) {
    formData.hasStorage = true;
  } else if (data.hasStorage === "false" || data.hasStorage === false) {
    formData.hasStorage = false;
  }

  if (data.hasStorage === "true" || data.hasStorage === true) {
    formData.hasStorage = true;
  } else if (data.hasStorage === "false" || data.hasStorage === false) {
    formData.hasStorage = false;
  }

  formData.hasFurnishedKitchen = data.hasFurnishedKitchen;
  formData.hasElevator = data.hasElevator;
  formData.hasAirConditioning = data.hasAirConditioning;
  formData.hasHeating = data.hasHeating;
  formData.hasTerrace = data.hasTerrace;
  // formData.terraceSurface = parseFloat(data.terraceSurface);
  if (!!data.terraceSurface || data.terraceSurface === 0) {
    if (data.terraceSurface !== 0) {
      formData.terraceSurface = parseFloat(
        data.terraceSurface.replace(",", ".")
      );
    } else {
      formData.terraceSurface = 0;
    }
  } else {
    formData.terraceSurface = null;
  }
  formData.hasCommunityGarden = data.hasCommunityGarden;
  formData.hasOwnGarden = data.hasOwnGarden;
  formData.hasCommunityPool = data.hasCommunityPool;
  formData.hasOwnPool = data.hasOwnPool;
  formData.hasIntercom = data.hasIntercom;
  formData.hasPorter = data.hasPorter;
  formData.garageType = parseInt(data.garageType);
  formData.managementCompanyId = data.managementCompanyPrinexId;
  if (!!data.outDoorCarpentry) {
    formData.outDoorCarpentry = data.outDoorCarpentry;
  } else {
    formData.outDoorCarpentry = null;
  }
  if (!!data.insideCarpentry) {
    formData.insideCarpentry = data.insideCarpentry;
  } else {
    formData.insideCarpentry = null;
  }
  if (!!data.furnishingStatus) {
    formData.furnishingStatus = data.furnishingStatus;
  } else {
    formData.furnishingStatus = null;
  }
  formData.isExterior = data.isExterior;
  if (!!data.floorEDC) {
    formData.floorEDC = data.floorEDC;
  } else {
    formData.floorEDC = null;
  }
  formData.hasBalconyEDC = data.hasBalconyEDC;
  if (!!data.districtEDC) {
    formData.districtEDC = data.districtEDC;
  } else {
    formData.districtEDC = null;
  }
  formData.statusEDC = data.statusEDC;
  formData.isFirstSeaLineEDC = data.isFirstSeaLineEDC;
  formData.isCityCenterEDC = data.isCityCenterEDC;
  if (!!data.heatingType) {
    formData.heatingType = data.heatingType;
  } else {
    formData.heatingType = null;
  }
  if (!!data.buildingYear) {
    formData.buildingYear = parseInt(data.buildingYear);
  } else {
    formData.buildingYear = null;
  }
  if (!!data.heatingEmissions || data.heatingEmissions === 0) {
    if (data.heatingEmissions !== 0) {
      formData.heatingEmissions = parseFloat(
        data.heatingEmissions.replace(",", ".")
      );
    } else {
      formData.heatingEmissions = 0;
    }
  } else {
    formData.heatingEmissions = null;
  }
  if (!!data.emissionsCertification) {
    formData.emissionsCertification = data.emissionsCertification;
  } else {
    formData.emissionsCertification = null;
  }
  if (!!data.buildingOrientation) {
    formData.buildingOrientation = data.buildingOrientation;
  } else {
    formData.buildingOrientation = null;
  }
  if (!!data.certificationCategory) {
    formData.certificationCategory = data.certificationCategory;
  } else {
    formData.certificationCategory = null;
  }

  //Referencia catastral
  if (!!data.cadastralReference) {
    formData.cadastralReference = data.cadastralReference;
  } else {
    formData.cadastralReference = null;
  }

  //Material gráfico
  if (!!data.urlYoutube) {
    formData.urlYoutube = data.urlYoutube;
  } else {
    formData.urlYoutube = null;
  }
  if (!!data.cloudVideo) {
    formData.cloudVideo = data.cloudVideo;
  } else {
    formData.cloudVideo = null;
  }
  formData.typeVirtualTour3D = data.typeVirtualTour3D || null;
  formData.urlVirtualTour3D = data.urlVirtualTour3D || null;

  //Localización - nuevos
  formData.urbanization = data.urbanization || null;

  //Características - nuevos
  formData.descriptionCA = data.descriptionCA || null;
  formData.descriptionExcCA = data.descriptionExcCA || null;
  formData.hasSecurityDoor = data.hasSecurityDoor ? true : false;
  formData.hasSecurityAlarm = data.hasSecurityAlarm ? true : false;
  formData.hasChimney = data.hasChimney ? true : false;
  formData.allowsPets = data.allowsPets ? true : false;
  formData.isRecommendedForChildren = data.isRecommendedForChildren
    ? true
    : false;
  formData.conditionedAirType = data.conditionedAirType || null;
  formData.buildableFloors = data.buildableFloors
    ? parseInt(data.buildableFloors)
    : null;
  formData.isOfficeBuilding = data.isOfficeBuilding ? true : false;
  formData.isTopFloor = data.isTopFloor ? true : false;
  formData.accessType = data.accessType || null;
  formData.hasHandicapAdaptedAccess = data.hasHandicapAdaptedAccess
    ? true
    : false;
  formData.hasfeaturesHandicapAdaptedUse = data.hasfeaturesHandicapAdaptedUse
    ? true
    : false;
  formData.liftsNumber = data.liftsNumber ? parseInt(data.liftsNumber) : null;
  formData.hasLiftAvailable = data.hasLiftAvailable ? true : false;
  formData.parkingSpacesNumber = data.parkingSpacesNumber
    ? parseInt(data.parkingSpacesNumber)
    : null;
  formData.hasParkingAutomaticDoor = data.hasParkingAutomaticDoor
    ? true
    : false;
  formData.hasParkingPlaceCovered = data.hasParkingPlaceCovered ? true : false;
  formData.hasUtilitiesElectricity = data.hasUtilitiesElectricity
    ? true
    : false;
  formData.hasUtilitiesNaturalGas = data.hasUtilitiesNaturalGas ? true : false;
  formData.hasUtilitiesRoadAccess = data.hasUtilitiesRoadAccess ? true : false;
  formData.hasUtilitiesSewerage = data.hasUtilitiesSewerage ? true : false;
  formData.hasUtilitiesSidewalk = data.hasUtilitiesSidewalk ? true : false;
  formData.hasUtilitiesStreetLighting = data.hasUtilitiesStreetLighting
    ? true
    : false;
  formData.hasUtilitiesWater = data.hasUtilitiesWater ? true : false;
  formData.nearestLocationKm = data.nearestLocationKm
    ? parseInt(data.nearestLocationKm)
    : null;
  formData.operationPriceCommunity = data.operationPriceCommunity
    ? parseInt(data.operationPriceCommunity)
    : null;
  formData.energyCertificationPerfomance = data.energyCertificationPerfomance
    ? parseFloat(
        data.energyCertificationPerfomance.toString().replace(",", ".")
      )
    : null;
  formData.energyCertificationType = data.energyCertificationType || null;
  formData.energyCertificateEmissionsValue =
    data.energyCertificateEmissionsValue
      ? parseFloat(
          data.energyCertificateEmissionsValue.toString().replace(",", ".")
        )
      : null;
  return formData;
};

export const bl = {
  Suelo: 1,
  Terciario: 2,
  Granular: 3,
};

export const bl2 = {
  1: "Suelo",
  2: "Terciario",
  3: "Granular",
};

/**
 * Convierte un valor que puede ser string o boolean a su tipo correcto.
 * Maneja los valores de nulleableList que pueden venir como "true"/"false" del select
 * o como true/false del backend.
 * @param {string|boolean|null|undefined} value
 * @returns {boolean|null}
 */
const parseNullableBoolean = (value) => {
  if (value === "true" || value === true) return true;
  if (value === "false" || value === false) return false;
  return null;
};

const parseDecimal = (value) => {
  if (value === undefined || value === null || value === "") return null;
  return parseFloat(value.toString().replace(",", "."));
};

const parseInteger = (value) => {
  if (value === undefined || value === null || value === "") return null;
  return parseInt(value.toString().replace(/[^0-9-]/g, ""));
};

export const buildFormDataEditTercerosAsset = (data) => {
  let vTerraceSurface = data.terraceSurface?.toString();

  const formData = {
    id: Number(data?.id),
    //GENERAL DATA
    managementCompanyId: data?.managementCompanyId,
    promotionName: data?.promotionName,
    businessLine: bl[data?.businessLine],
    subPortfolio: data?.subPortfolio,
    //LOCALIZACION
    typeOfRoad: data?.typeOfRoad,
    road: data?.road,
    number: data?.number,
    floor: data?.floor,
    door: data?.door,
    stair: data?.stair,
    block: data?.block,
    postalCode: data?.postalCode,
    municipalityId: data?.municipalityId,
    latitude: !!data?.latitude
      ? data.latitude.toString().replace(",", ".")
      : null,
    longitude: !!data?.longitude
      ? data.longitude.toString().replace(",", ".")
      : null,
    district: data?.district,
    hideNumber: data?.hideNumber ? data?.hideNumber : false,
    hideAddress: data?.hideAddress ? data?.hideAddress : false,
    commuterTrain: data?.commuterTrain,
    bus: data?.bus,
    highway: data?.highway,
    //CARACTERISTICAS INMUEBLE
    description: data?.description,
    descriptionEN: data?.descriptionEN,
    descriptionFR: data?.descriptionFR,
    delegationId: Number(data?.delegationId),
    commercialNetType: Number(data?.commercialNetType),
    subTypeId: data?.subTypeId,
    crmPrice: parseSpanishPrice(data.crmPrice),
    bathrooms: Number(data?.bathrooms),
    bedrooms: Number(data?.bedrooms),
    builtM2: data?.builtM2.toString(),
    builtInWardrobe: data?.builtInWardrobe ? data?.builtInWardrobe : false,
    hasFurnishedKitchen: data?.hasFurnishedKitchen
      ? data?.hasFurnishedKitchen
      : false,
    hasElevator: data?.hasElevator ? data?.hasElevator : false,
    hasAirConditioning: data?.hasAirConditioning
      ? data?.hasAirConditioning
      : false,
    hasHeating: data?.hasHeating ? data?.hasHeating : false,
    hasTerrace: data?.hasTerrace ? data?.hasTerrace : false,
    terraceSurface:
      vTerraceSurface == undefined
        ? undefined
        : Number(vTerraceSurface.replace(",", ".")),
    hasCommunityGarden: data?.hasCommunityGarden
      ? data?.hasCommunityGarden
      : false,
    hasOwnGarden: data?.hasOwnGarden ? data?.hasOwnGarden : false,
    hasCommunityPool: data?.hasCommunityPool ? data?.hasCommunityPool : false,
    hasOwnPool: data?.hasOwnPool ? data?.hasOwnPool : false,
    hasIntercom: data?.hasIntercom ? data?.hasIntercom : false,
    hasPorter: data?.hasPorter ? data?.hasPorter : false,
    garageType: Number(data?.garageType),
    outDoorCarpentry: data?.outDoorCarpentry,
    insideCarpentry: data?.insideCarpentry,
    furnishingStatus: data?.furnishingStatus,
    isExterior: data?.isExterior ? data?.isExterior : false,
    floorEDC: data?.floorEDC,
    hasBalconyEDC: data?.hasBalconyEDC ? data?.hasBalconyEDC : false,
    districtEDC: data?.districtEDC,
    statusEDC: data?.statusEDC,
    isFirstSeaLineEDC: data?.isFirstSeaLineEDC
      ? data?.isFirstSeaLineEDC
      : false,
    isCityCenterEDC: data?.isCityCenterEDC ? data?.isCityCenterEDC : false,
    heatingType: data?.heatingType,
    buildingYear: Number(data?.buildingYear),
    heatingEmissions: Number(data?.heatingEmissions),
    emissionsCertification: data?.emissionsCertification,
    buildingOrientation: data?.buildingOrientation,
    certificationCategory: data?.certificationCategory,
    isBrandNewConstruction:
      data?.isBrandNewConstruction === "true" ? true : false,
    //REFERENCIA CATASTRAL
    cadastralReference: data?.cadastralReference,
    //LOCALIZACION - NUEVOS
    urbanization: data?.urbanization,
    //CARACTERISTICAS INMUEBLE - NUEVOS
    descriptionCA: data?.descriptionCA,
    descriptionExcCA: data?.descriptionExcCA,
    hasSecurityDoor: data?.hasSecurityDoor ? data?.hasSecurityDoor : false,
    hasSecurityAlarm: data?.hasSecurityAlarm ? data?.hasSecurityAlarm : false,
    hasChimney: data?.hasChimney ? data?.hasChimney : false,
    allowsPets: data?.allowsPets ? data?.allowsPets : false,
    isRecommendedForChildren: data?.isRecommendedForChildren
      ? data?.isRecommendedForChildren
      : false,
    conditionedAirType: data?.conditionedAirType,
    buildableFloors: parseInteger(data?.buildableFloors),
    isOfficeBuilding: data?.isOfficeBuilding ? data?.isOfficeBuilding : false,
    isTopFloor: data?.isTopFloor ? data?.isTopFloor : false,
    accessType: data?.accessType,
    hasHandicapAdaptedAccess: data?.hasHandicapAdaptedAccess
      ? data?.hasHandicapAdaptedAccess
      : false,
    hasfeaturesHandicapAdaptedUse: data?.hasfeaturesHandicapAdaptedUse
      ? data?.hasfeaturesHandicapAdaptedUse
      : false,
    liftsNumber: parseInteger(data?.liftsNumber),
    hasLiftAvailable: data?.hasLiftAvailable ? data?.hasLiftAvailable : false,
    parkingSpacesNumber: parseInteger(data?.parkingSpacesNumber),
    hasParkingAutomaticDoor: data?.hasParkingAutomaticDoor
      ? data?.hasParkingAutomaticDoor
      : false,
    hasParkingPlaceCovered: data?.hasParkingPlaceCovered
      ? data?.hasParkingPlaceCovered
      : false,
    hasUtilitiesElectricity: data?.hasUtilitiesElectricity
      ? data?.hasUtilitiesElectricity
      : false,
    hasUtilitiesNaturalGas: data?.hasUtilitiesNaturalGas
      ? data?.hasUtilitiesNaturalGas
      : false,
    hasUtilitiesRoadAccess: data?.hasUtilitiesRoadAccess
      ? data?.hasUtilitiesRoadAccess
      : false,
    hasUtilitiesSewerage: data?.hasUtilitiesSewerage
      ? data?.hasUtilitiesSewerage
      : false,
    hasUtilitiesSidewalk: data?.hasUtilitiesSidewalk
      ? data?.hasUtilitiesSidewalk
      : false,
    hasUtilitiesStreetLighting: data?.hasUtilitiesStreetLighting
      ? data?.hasUtilitiesStreetLighting
      : false,
    hasUtilitiesWater: data?.hasUtilitiesWater
      ? data?.hasUtilitiesWater
      : false,
    nearestLocationKm: parseInteger(data?.nearestLocationKm),
    operationPriceCommunity: parseInteger(data?.operationPriceCommunity),
    energyCertificationPerfomance: parseDecimal(
      data?.energyCertificationPerfomance
    ),
    energyCertificationType: data?.energyCertificationType,
    energyCertificateEmissionsValue: parseDecimal(
      data?.energyCertificateEmissionsValue
    ),
    //MATERIAL GRAFICO
    urlYoutube: data?.urlYoutube,
    cloudVideo: data?.cloudVideo,
    urlDossier: data?.dossier,
    typeVirtualTour3D: data?.typeVirtualTour3D,
    urlVirtualTour3D: data?.urlVirtualTour3D,
    //MARKETING
    isHighlighted: data?.isHighlighted,
    btsGroup: data?.btsGroup || "",
    hasStorage: parseNullableBoolean(data?.hasStorage),
    hasGarage: parseNullableBoolean(data?.hasGarage),

    // CAMPOS NUEVOS TERCEROS
    buildingAboveGroundM2: parseDecimal(data?.buildingAboveGroundM2),
    freeResidentialM2: parseDecimal(data?.freeResidentialM2),
    protectedResidentialM2: parseDecimal(data?.protectedResidentialM2),
    terciaryM2: parseDecimal(data?.terciaryM2),
    comercialM2: parseDecimal(data?.comercialM2),
    industrialM2: parseDecimal(data?.industrialM2),
    hoteliersM2: parseDecimal(data?.hoteliersM2),
    othersM2: parseDecimal(data?.othersM2),
    officeM2: parseDecimal(data?.officeM2),
    warehouseM2: parseDecimal(data?.warehouseM2),
    groundFloorM2: parseDecimal(data?.groundFloorM2),
    firstFloorM2: parseDecimal(data?.firstFloorM2),
    secondFloorM2: parseDecimal(data?.secondFloorM2),
    usefulM2: parseDecimal(data?.usefulM2),
    freeHeight: parseDecimal(data?.freeHeight),
    grossM2: parseDecimal(data?.grossM2),
    betsM2: parseDecimal(data?.betsM2),
    plotArea: parseDecimal(data?.plotArea),
    buildableVolume: parseDecimal(data?.buildableVolume),

    aboveGroundFloorAmount: parseInteger(data?.aboveGroundFloorAmount),
    floorAmount: parseInteger(data?.floorAmount),
    category: parseInteger(data?.category),
    roomsNumber: parseInteger(data?.roomsNumber),
    piers: parseInteger(data?.piers),
    gates: parseInteger(data?.gates),
    parkingPlacesAmount: parseInteger(data?.parkingPlacesAmount),
    households: parseInteger(data?.households),
    freeHouseholds: parseInteger(data?.freeHouseholds),
    protectedFreeHouseholds: parseInteger(data?.protectedFreeHouseholds),
    buildableHomes: parseInteger(data?.buildableHomes),

    // Porcentajes
    wipPercentage: parseDecimal(data?.wipPercentage),
    scopePercent: parseDecimal(data?.scopePercent),
    ownershipPercent: parseDecimal(data?.ownershipPercent),
    //segmentation
    segmentationPrimary: data.segmentationPrimary,
    segmentationPrimaryType: data.segmentationPrimaryType,
    segmentationSecondary: data.segmentationSecondary,
    segmentationSecondaryType: data.segmentationSecondaryType,

    targetWebsites: data?.targetWebsites,

    internalValuationAmount: data?.internalValuationAmount
      ? parseSpanishPrice(data.internalValuationAmount)
      : null,
    internalValuationDate: data?.internalValuationDate || null,
    valuationStatus: data?.valuationStatus || null,
    pricingComment: data?.pricingComment || null,
    bp: data?.bp || null,
  };
  return formData;
};

/**
 * Valid required fields
 * @param {*} data
 * @returns
 */
export const validateRequiredFields = (data, id) => {
  let emptyRequredFields = [];
  const businessLine =
    typeof data.businessLine === "number"
      ? data.businessLine
      : bl[data.businessLine];

  if (!data.subPortfolio) {
    emptyRequredFields.push({
      name: "subPortfolio",
      label: "Subcartera ",
    });
  }
  if (!data.promotionName) {
    emptyRequredFields.push({
      name: "promotionName",
      label: "Nombre de Promoción Prínex",
    });
  }
  if (!data.managementCompanyId) {
    emptyRequredFields.push({
      name: "managementCompanyId",
      label: "Sociedad Propietaria",
    });
  }
  if (!data.typeOfRoad || data.typeOfRoad === "-Seleccionar-") {
    emptyRequredFields.push({
      name: "typeOfRoad",
      label: "Tipo de vía",
    });
  }
  if (!data.road) {
    emptyRequredFields.push({
      name: "road",
      label: "Vía",
    });
  }
  if (!data.number) {
    emptyRequredFields.push({
      name: "number",
      label: "Número",
    });
  }
  if (!data.floor && isRequiredForLineBusiness([bl.Granular], businessLine)) {
    emptyRequredFields.push({
      name: "floor",
      label: "Piso",
    });
  }
  if (!data.door && isRequiredForLineBusiness([bl.Granular], businessLine)) {
    emptyRequredFields.push({
      name: "door",
      label: "Puerta",
    });
  }
  if (!data.postalCode) {
    emptyRequredFields.push({
      name: "postalCode",
      label: "Código postal",
    });
  }
  if (!data.municipalityId) {
    emptyRequredFields.push({
      name: "municipalityId",
      label: "Municipio",
    });
  }
  if (!data.provinceId) {
    emptyRequredFields.push({
      name: "provinceId",
      label: "Provincia",
    });
  }
  if (!data.latitude) {
    emptyRequredFields.push({
      name: "latitude",
      label: "Latitud",
    });
  }
  if (!data.longitude) {
    emptyRequredFields.push({
      name: "longitude",
      label: "Longitud",
    });
  }
  if (!data.commercialNetType) {
    emptyRequredFields.push({
      name: "commercialNetType",
      label: "Tipo de red comercial",
    });
  }
  if (!data.subTypeId) {
    emptyRequredFields.push({
      name: "subTypeId",
      label: "Subtipo",
    });
  }
  if (!data.crmPrice) {
    emptyRequredFields.push({
      name: "crmPrice",
      label: "Precio",
    });
  }
  if (
    !data.bathrooms &&
    data.bathrooms !== 0 &&
    isRequiredForLineBusiness([bl.Granular], businessLine)
  ) {
    emptyRequredFields.push({
      name: "bathrooms",
      label: "Número de baños",
    });
  }
  if (
    !data.bedrooms &&
    data.bedrooms !== 0 &&
    isRequiredForLineBusiness([bl.Granular], businessLine)
  ) {
    emptyRequredFields.push({
      name: "bedrooms",
      label: "Número de dormitorios",
    });
  }
  if (!data.builtM2) {
    emptyRequredFields.push({
      name: "builtM2",
      label: "m² construídos",
    });
  }
  if (!data.statusEDC) {
    emptyRequredFields.push({
      name: "statusEDC",
      label: "Estado",
    });
  }
  if (id && !data.delegationId) {
    emptyRequredFields.push({
      name: "delegationId",
      label: "Delegación",
    });
  }
  if (
    (data.hasStorage === "" || data.hasStorage === undefined) &&
    isRequiredForLineBusiness([bl.Granular], businessLine)
  ) {
    emptyRequredFields.push({
      name: "hasStorage",
      label: "Trastero",
    });
  }
  if (
    (data.hasGarage === "" || data.hasGarage === undefined) &&
    isRequiredForLineBusiness([bl.Granular], businessLine)
  ) {
    emptyRequredFields.push({
      name: "hasGarage",
      label: "Garaje",
    });
  }

  return emptyRequredFields;
};

export const getMetadataAsset = (id) => {
  return [
    {
      label: "Datos generales del activo",
      id: "generalData",
      collapsable: true,
      metadata: [
        {
          label: "Id (interno)",
          name: "id",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Id Prínex",
          name: "prinexId",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Expediente",
          name: "dossierCode",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Inmueble",
          name: "propertyCode",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Id Promoción Prínex",
          name: "promotionCode",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Nombre de Promoción Prínex",
          name: "promotionName",
          type: "textarea",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Línea Negocio",
          name: "businessLine",
          type: "list",
          typeList: "Normal",
          listName: "businessLines",
          propertyList: "id",
          propertyId: "id",
          propertyName: "translation",
          hidden: hiddenFilter,
          disabled: disabledTrue,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Delegación",
          name: "delegationId",
          type: "list",
          typeList: "Normal",
          listName: "delegationList",
          propertyId: "id",
          propertyName: "name",
          disabled: isSuperAdmin && id ? disabledFalse : disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Forzado",
          name: "delegationForced",
          type: "checkbox",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Sociedad Propietaria Id",
          name: "managementCompanyPrinexId",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Sociedad Propietaria Nombre",
          name: "managementCompany",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Sociedad Propietaria NIF",
          name: "managementCompanyNif",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Sociedad Propietaria Domi",
          name: "managementCompanyAddress",
          type: "textarea",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Estado Comercial",
          name: "commercialStatusId",
          type: "textFromList",
          typeList: "Normal",
          listName: "appCommercialStatus",
          propertyList: "name",
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
      ],
    },
    {
      label: "Particulares",
      id: "privates",
      collapsable: true,
      metadata: [
        {
          label: "OK PBC",
          name: "okPBC",
          type: "list",
          typeList: "Normal",
          listName: "nulleableList",
          propertyId: "value",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "OK Registral",
          name: "okRegistral",
          type: "list",
          typeList: "Normal",
          listName: "nulleableList",
          propertyId: "value",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Fecha firma del mandato",
          name: "mandateDateSign",
          type: "date",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          visibleFor: [PORTFOLIOS.QUASAR, PORTFOLIOS.NS, PORTFOLIOS.ANTICIPA],
        },
        {
          label: "Modalidad de mandato",
          name: "mandateModality",
          type: "sampleList",
          listName: "mandateModality",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Duración del mandato",
          name: "mandateDuration",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
      ],
    },
    {
      label: "Localización",
      id: "localization",
      collapsable: true,
      metadata: [
        {
          label: "Tipo de vía*",
          name: "typeOfRoad",
          required: true,
          type: "sampleList",
          listName: "typeOfRoads",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Vía*",
          name: "road",
          required: true,
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Número*",
          name: "number",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          min: 0,
          languageSensitive: false,
        },
        {
          label: "Piso*",
          name: "floor",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Puerta*",
          name: "door",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Escalera",
          name: "stair",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Bloque",
          name: "block",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Código postal*",
          name: "postalCode",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Dirección completa",
          name: "fullAddress",
          type: "textarea",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Provincia INE*",
          name: "provinceId",
          required: true,
          type: "list",
          typeList: "Normal",
          listName: "appProvinces",
          propertyId: "id",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Municipio INE*",
          name: "municipalityId",
          required: true,
          type: "list",
          typeList: "Normal",
          listName: "auxMunicipalities",
          propertyId: "id",
          propertyName: "name",
          disabled: id ? disabledFalse : disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Latitud*",
          name: "latitude",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Longitud*",
          name: "longitude",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Mapa",
          name: "map",
          type: "map",
          lat: "latitude",
          lng: "longitude",
        },
        {
          label: "Distrito",
          name: "district",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Ocultar número",
          name: "hideNumber",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Ocultar dirección",
          name: "hideAddress",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Cercanías",
          name: "commuterTrain",
          type: "text",
          disabled: notPermissionFieldsForm,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Autobús",
          name: "bus",
          type: "text",
          disabled: notPermissionFieldsForm,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Carretera",
          name: "highway",
          type: "text",
          disabled: notPermissionFieldsForm,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Urbanización",
          name: "urbanization",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
      ],
    },
    {
      label: "Características del inmueble",
      id: "features",
      collapsable: true,
      metadata: [
        {
          label: "Activo",
          name: "name",
          type: "textarea",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Descripción activo",
          name: "description",
          type: "texteditor",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: true,
        },
        {
          label: "Delegación",
          name: "delegationId",
          type: "list",
          typeList: "Normal",
          listName: "delegationList",
          propertyId: "id",
          propertyName: "name",
          disabled: isSuperAdmin && id ? disabledFalse : disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Forzado",
          name: "delegationForced",
          type: "checkbox",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Tipo de red comercial*",
          name: "commercialNetType",
          required: true,
          type: "list",
          typeList: "Normal",
          listName: "commercialNetType",
          propertyId: "Id",
          propertyName: "translation",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Tipo*",
          name: "typeId",
          required: true,
          type: "list",
          typeList: "Normal",
          listName: "assetType",
          propertyId: "Id",
          propertyName: "translation",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Subtipo*",
          name: "subTypeId",
          required: true,
          type: "list",
          typeList: "Normal",
          listName: "auxAssetSubTypes",
          propertyId: "id",
          propertyName: "name",
          disabled: id ? disabledFalse : disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Precio*",
          name: "crmPrice",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          addon: "€",
          numberSeparator: true,
          min: 0,
        },
        {
          label: "Número de baños*",
          name: "bathrooms",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Número de dormitorios*",
          name: "bedrooms",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "m² construídos*",
          name: "builtM2",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Armarios empotrados",
          name: "builtInWardrobe",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Trastero*",
          name: "hasStorage",
          required: true,
          type: "list",
          typeList: "Normal",
          listName: "nulleableList",
          propertyId: "value",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Cocina amueblada",
          name: "hasFurnishedKitchen",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Ascensor",
          name: "hasElevator",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Aire acondicionado",
          name: "hasAirConditioning",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Calefacción",
          name: "hasHeating",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Terraza",
          name: "hasTerrace",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Superficie de la terraza",
          name: "terraceSurface",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Jardín comunitario",
          name: "hasCommunityGarden",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Jardín propio",
          name: "hasOwnGarden",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Piscina comunitaria",
          name: "hasCommunityPool",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Piscina propia",
          name: "hasOwnPool",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Portero automático",
          name: "hasIntercom",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Portero físico",
          name: "hasPorter",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Garaje*",
          name: "hasGarage",
          required: true,
          type: "list",
          typeList: "Normal",
          listName: "nulleableList",
          propertyId: "value",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Tipo de Garaje",
          name: "garageType",
          type: "list",
          typeList: "Normal",
          listName: "garageType",
          propertyId: "Id",
          propertyName: "translation",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Carpintería exterior",
          name: "outDoorCarpentry",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Carpintería interior",
          name: "insideCarpentry",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Estado de mobiliario (amueblamiento)",
          name: "furnishingStatus",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Exterior",
          name: "isExterior",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Planta",
          name: "floorEDC",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Balcón",
          name: "hasBalconyEDC",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Barrio",
          name: "districtEDC",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Estado*",
          name: "statusEDC",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Primera línea de mar",
          name: "isFirstSeaLineEDC",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Centro ciudad",
          name: "isCityCenterEDC",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Tipo de calefacción",
          name: "heatingType",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Año de construcción",
          name: "buildingYear",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Emisiones co2/m2",
          name: "heatingEmissions",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Etiqueta de emisiones",
          name: "emissionsCertification",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Orientación del activo",
          name: "buildingOrientation",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Letra Energética",
          name: "certificationCategory",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "A estrenar obra nueva",
          name: "isBrandNewConstruction",
          type: "list",
          typeList: "Normal",
          listName: "nulleableList",
          propertyId: "value",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Puerta de seguridad",
          name: "hasSecurityDoor",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Alarma de seguridad",
          name: "hasSecurityAlarm",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Chimenea",
          name: "hasChimney",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Permite mascotas",
          name: "allowsPets",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Recomendado para niños",
          name: "isRecommendedForChildren",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Tipo de aire acondicionado",
          name: "conditionedAirType",
          type: "list",
          typeList: "Normal",
          listName: "conditionedAirTypes",
          propertyId: "Id",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Plantas edificables",
          name: "buildableFloors",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Edificio de oficinas",
          name: "isOfficeBuilding",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Última planta",
          name: "isTopFloor",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Tipo de acceso",
          name: "accessType",
          type: "list",
          typeList: "Normal",
          listName: "accessTypes",
          propertyId: "Id",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Acceso adaptado discapacitados",
          name: "hasHandicapAdaptedAccess",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Uso adaptado discapacitados",
          name: "hasfeaturesHandicapAdaptedUse",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Número de ascensores",
          name: "liftsNumber",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Ascensor disponible",
          name: "hasLiftAvailable",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Número de plazas de parking",
          name: "parkingSpacesNumber",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Parking con puerta automática",
          name: "hasParkingAutomaticDoor",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Plaza de parking cubierta",
          name: "hasParkingPlaceCovered",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Suministro de electricidad",
          name: "hasUtilitiesElectricity",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Suministro de gas natural",
          name: "hasUtilitiesNaturalGas",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Acceso por carretera",
          name: "hasUtilitiesRoadAccess",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Alcantarillado",
          name: "hasUtilitiesSewerage",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Acera",
          name: "hasUtilitiesSidewalk",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Alumbrado público",
          name: "hasUtilitiesStreetLighting",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Suministro de agua",
          name: "hasUtilitiesWater",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Distancia localización más cercana (km)",
          name: "nearestLocationKm",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Gastos comunidad (operación)",
          name: "operationPriceCommunity",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          addon: "€",
          min: 0,
        },
        {
          label: "Rendimiento certificación energética",
          name: "energyCertificationPerfomance",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Tipo de certificación energética",
          name: "energyCertificationType",
          type: "list",
          typeList: "Normal",
          listName: "energyCertificationTypes",
          propertyId: "Id",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Valor emisiones certificado energético",
          name: "energyCertificateEmissionsValue",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
      ],
    },
    {
      label: "Ref. Catastral",
      id: "catastralRef",
      collapsable: true,
      metadata: [
        {
          label: "Ref. Catastral",
          name: "cadastralReference",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
      ],
    },
    {
      label: "Material gráfico",
      id: "graphicData",
      collapsable: true,
      metadata: [
        {
          label: "URL Youtube",
          name: "urlYoutube",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Video Cloud",
          name: "cloudVideo",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "URL TourVirtual",
          name: "urlVirtualTour",
          type: "textarea",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Plano",
          name: "hasPlans",
          type: "checkbox",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Decorview",
          name: "decorview",
          type: "checkbox",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Fotos Decorview",
          name: "decorviewImages",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,

          languageSensitive: false,
        },
        {
          label: "Número de Fotos",
          name: "numberOfPhotos",
          type: "number",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Letras de las fotos",
          name: "photoLetters",
          type: "textarea",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Fotos Plano",
          name: "schemeImages",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Dossier",
          name: "urlDossier",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Validación fotos",
          name: "areValidPhotos",
          type: "checkbox",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Observaciones fotos",
          name: "photoDetails",
          type: "textarea",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Comentarios fotos",
          name: "photoComments",
          type: "textarea",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Fecha última modificación Floorfy",
          name: "lastFloorfyModificationDate",
          type: "dateText",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Tipo tour virtual 3D",
          name: "typeVirtualTour3D",
          type: "list",
          typeList: "Normal",
          listName: "typeVirtualTour3DOptions",
          propertyId: "Id",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "URL tour virtual 3D",
          name: "urlVirtualTour3D",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Mostrar en web",
          name: "targetWebsites",
          type: "list",
          typeList: "Normal",
          listName: "targetWebsitesOptions",
          propertyId: "id",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
      ],
    },
    {
      label: "Auditoría",
      id: "audit",
      collapsable: true,
      metadata: [
        {
          label: "Fecha Creación",
          name: "creationTime",
          type: "dateText",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Usuario Creación",
          name: "creatorId",
          type: "textFromList",
          typeList: "Normal",
          listName: "userList",
          propertyList: "name",
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Fecha Última Modificación",
          name: "lastModificationTime",
          type: "dateText",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Usuario Modificación",
          name: "lastModifierId",
          type: "textFromList",
          typeList: "Normal",
          listName: "userList",
          propertyList: "name",
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Fecha Borrado",
          name: "deletionTime",
          type: "dateText",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: true,
        },
        {
          label: "Usuario Borrado",
          name: "deleterId",
          type: "textFromList",
          typeList: "Normal",
          listName: "userList",
          propertyList: "name",
          hidden: hiddenFilter,
          languageSensitive: false,
        },
      ],
    },
  ];
};

export const getMetadataNewActivoTerceros = (id, lineaNegocio) => {
  return [
    {
      label: "Datos generales del activo",
      id: "generalData",
      collapsable: true,
      metadata: [
        {
          label: "Id (interno)",
          name: "id",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Id Prínex",
          name: "prinexId",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Expediente",
          name: "dossierCode",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Agrupación OSS",
          name: "btsGroup",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Inmueble",
          name: "propertyCode",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Id Promoción Prínex",
          name: "promotionCode",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Nombre de Promoción Prínex",
          name: "promotionName",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
          required: true,
        },
        {
          label: "Línea Negocio",
          name: "businessLine",
          type: "list",
          typeList: "Normal",
          listName: "businessLines",
          propertyId: "id",
          propertyName: "translation",
          hidden: hiddenFilter,
          disabled: disabledTrue,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Delegación",
          name: "delegationId",
          type: "list",
          typeList: "Normal",
          listName: "delegationList",
          propertyId: "id",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Forzado",
          name: "delegationForced",
          type: "checkbox",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Delegado",
          name: "delegate",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Subcartera",
          name: "subPortfolio",
          type: "list",
          typeList: "Normal",
          listName: "subPortfolios",
          propertyId: "id",
          propertyName: "name",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
          required: true,
        },
        {
          label: "Sociedad Propietaria Id",
          name: "managementCompanyId",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Sociedad Propietaria Nombre",
          name: "managementCompanyId",
          required: true,
          type: "list",
          typeList: "Normal",
          listName: "managmentCompanyList",
          propertyId: "Id",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Sociedad Propietaria NIF",
          name: "managementCompanyNif",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Sociedad Propietaria Domi",
          name: "managementCompanyAddress",
          type: "textarea",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Estado Comercial",
          name: "commercialStatusId",
          type: "textFromList",
          typeList: "Normal",
          listName: "appCommercialStatus",
          propertyList: "name",
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Situación Especial",
          name: "specialSituation",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
      ],
    },
    {
      label: "Localización",
      id: "localization",
      collapsable: true,
      metadata: [
        {
          label: "Tipo de vía*",
          name: "typeOfRoad",
          required: true,
          type: "sampleList",
          listName: "typeOfRoads",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Vía*",
          name: "road",
          required: true,
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Número*",
          name: "number",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          min: 0,
          languageSensitive: false,
        },
        {
          label: "Piso",
          name: "floor",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          requiredForBusinessLines: [3],
        },
        {
          label: "Puerta",
          name: "door",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          requiredForBusinessLines: [3],
        },
        {
          label: "Escalera",
          name: "stair",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Bloque",
          name: "block",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Código postal*",
          name: "postalCode",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Dirección completa",
          name: "fullAddress",
          type: "textarea",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Provincia INE*",
          name: "provinceId",
          required: true,
          type: "list",
          typeList: "Normal",
          listName: "appProvinces",
          propertyId: "id",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Municipio INE*",
          name: "municipalityId",
          required: true,
          type: "list",
          typeList: "Normal",
          listName: "auxMunicipalities",
          propertyId: "id",
          propertyName: "name",
          disabled: id ? disabledFalse : disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Latitud*",
          name: "latitude",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Longitud*",
          name: "longitude",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Mapa",
          name: "map",
          type: "map",
          lat: "latitude",
          lng: "longitude",
        },
        {
          label: "Distrito",
          name: "district",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Ocultar número",
          name: "hideNumber",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Ocultar dirección",
          name: "hideAddress",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Cercanías",
          name: "commuterTrain",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Autobús",
          name: "bus",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Carretera",
          name: "highway",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Urbanización",
          name: "urbanization",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
      ],
    },
    {
      label: "Características del inmueble",
      id: "features",
      collapsable: true,
      metadata: [
        {
          label: "Activo",
          name: "name",
          type: "textarea",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Descripción activo",
          name: "description",
          type: "texteditor",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: true,
        },
        //  {
        //   label: "Delegación",
        //   name: "delegationId",
        //   type: "list",
        //   typeList: "Normal",
        //   listName: "delegationList",
        //   propertyId: "id",
        //   propertyName: "name",
        //   disabled: disabledFalse,
        //   hidden: hiddenFilter,
        //   languageSensitive: false,
        // },
        {
          label: "Tipo de red comercial*",
          name: "commercialNetType",
          required: true,
          type: "list",
          typeList: "Normal",
          listName: "commercialNetType",
          propertyId: "Id",
          propertyName: "translation",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Tipo*",
          name: "typeId",
          required: true,
          type: "list",
          typeList: "Normal",
          listName: "assetType",
          propertyId: "Id",
          propertyName: "translation",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Subtipo*",
          name: "subTypeId",
          required: true,
          type: "list",
          typeList: "Normal",
          listName: "auxAssetSubTypes",
          propertyId: "id",
          propertyName: "name",
          disabled: id ? disabledFalse : disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Precio*",
          name: "crmPrice",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          addon: "€",
          numberSeparator: true,
          min: 0,
        },
        {
          label: "Número de baños",
          name: "bathrooms",
          type: "text",
          requiredForBusinessLines: [3],
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Número de dormitorios",
          name: "bedrooms",
          type: "text",
          requiredForBusinessLines: [3],
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "m² construídos*",
          name: "builtM2",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Armarios empotrados",
          name: "builtInWardrobe",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Trastero",
          name: "hasStorage",
          type: "list",
          requiredForBusinessLines: [3],
          typeList: "Normal",
          listName: "nulleableList",
          propertyId: "value",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Cocina amueblada",
          name: "hasFurnishedKitchen",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Ascensor",
          name: "hasElevator",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Aire acondicionado",
          name: "hasAirConditioning",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Calefacción",
          name: "hasHeating",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Terraza",
          name: "hasTerrace",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Superficie de la terraza",
          name: "terraceSurface",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Jardín comunitario",
          name: "hasCommunityGarden",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Jardín propio",
          name: "hasOwnGarden",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Piscina comunitaria",
          name: "hasCommunityPool",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Piscina propia",
          name: "hasOwnPool",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Portero automático",
          name: "hasIntercom",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Portero físico",
          name: "hasPorter",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Garaje",
          name: "hasGarage",
          type: "list",
          requiredForBusinessLines: [3],
          typeList: "Normal",
          listName: "nulleableList",
          propertyId: "value",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Tipo de Garaje",
          name: "garageType",
          type: "list",
          typeList: "Normal",
          listName: "garageType",
          propertyId: "Id",
          propertyName: "translation",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Carpintería exterior",
          name: "outDoorCarpentry",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Carpintería interior",
          name: "insideCarpentry",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Estado de mobiliario (amueblamiento)",
          name: "furnishingStatus",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Exterior",
          name: "isExterior",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Planta",
          name: "floorEDC",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Balcón",
          name: "hasBalconyEDC",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Barrio",
          name: "districtEDC",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Estado*",
          name: "statusEDC",
          required: true,
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Primera línea de mar",
          name: "isFirstSeaLineEDC",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Centro ciudad",
          name: "isCityCenterEDC",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Tipo de calefacción",
          name: "heatingType",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Año de construcción",
          name: "buildingYear",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Emisiones co2/m2",
          name: "heatingEmissions",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Etiqueta de emisiones",
          name: "emissionsCertification",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Orientación del activo",
          name: "buildingOrientation",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Letra Energética",
          name: "certificationCategory",
          type: "sampleList",
          listName: "CertificationCategories",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "A estrenar obra nueva",
          name: "isBrandNewConstruction",
          type: "list",
          typeList: "Normal",
          listName: "nulleableList",
          propertyId: "value",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Puerta de seguridad",
          name: "hasSecurityDoor",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Alarma de seguridad",
          name: "hasSecurityAlarm",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Chimenea",
          name: "hasChimney",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Permite mascotas",
          name: "allowsPets",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Recomendado para niños",
          name: "isRecommendedForChildren",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Tipo de aire acondicionado",
          name: "conditionedAirType",
          type: "list",
          typeList: "Normal",
          listName: "conditionedAirTypes",
          propertyId: "Id",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Plantas edificables",
          name: "buildableFloors",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Edificio de oficinas",
          name: "isOfficeBuilding",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Última planta",
          name: "isTopFloor",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Tipo de acceso",
          name: "accessType",
          type: "list",
          typeList: "Normal",
          listName: "accessTypes",
          propertyId: "Id",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Acceso adaptado discapacitados",
          name: "hasHandicapAdaptedAccess",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Uso adaptado discapacitados",
          name: "hasfeaturesHandicapAdaptedUse",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Número de ascensores",
          name: "liftsNumber",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Ascensor disponible",
          name: "hasLiftAvailable",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Número de plazas de parking",
          name: "parkingSpacesNumber",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Parking con puerta automática",
          name: "hasParkingAutomaticDoor",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Plaza de parking cubierta",
          name: "hasParkingPlaceCovered",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Suministro de electricidad",
          name: "hasUtilitiesElectricity",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Suministro de gas natural",
          name: "hasUtilitiesNaturalGas",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Acceso por carretera",
          name: "hasUtilitiesRoadAccess",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Alcantarillado",
          name: "hasUtilitiesSewerage",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Acera",
          name: "hasUtilitiesSidewalk",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Alumbrado público",
          name: "hasUtilitiesStreetLighting",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Suministro de agua",
          name: "hasUtilitiesWater",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Distancia localización más cercana (km)",
          name: "nearestLocationKm",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Gastos comunidad (operación)",
          name: "operationPriceCommunity",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          addon: "€",
          min: 0,
        },
        {
          label: "Rendimiento certificación energética",
          name: "energyCertificationPerfomance",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Tipo de certificación energética",
          name: "energyCertificationType",
          type: "list",
          typeList: "Normal",
          listName: "energyCertificationTypes",
          propertyId: "Id",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Valor emisiones certificado energético",
          name: "energyCertificateEmissionsValue",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
      ],
    },
    {
      label: "Ref. Catastral",
      id: "catastralRef",
      collapsable: true,
      metadata: [
        {
          label: "Ref. Catastral",
          name: "cadastralReference",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
      ],
    },
    {
      label: "Terciario",
      id: "terciary",
      collapsable: true,
      metadata: [
        {
          label: "Responsable Terciario",
          name: "responsibleTertiaryId",
          type: "list",
          typeList: "Normal",
          listName: "appResponsibleTertiary",
          propertyId: "Id",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² sobre rasante",
          name: "aboveGroundM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² bajo rasante",
          name: "lowFlushM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Estado de conservación",
          name: "conservationStatus",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Número de plantas",
          name: "floorAmount",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          min: 0,
          languageSensitive: false,
        },
        {
          label: "Planta/s rasante",
          name: "aboveGroundFloorAmount",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          min: 0,
          languageSensitive: false,
        },
        {
          label: "Distribución",
          name: "distribution",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Fachada m/l",
          name: "facade",
          type: "number",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          min: 0,
          languageSensitive: false,
        },
        {
          label: "m² oficinas",
          name: "officeM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² almacén",
          name: "warehouseM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² planta baja",
          name: "groundFloorM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² primera planta",
          name: "firstFloorM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² segunda planta",
          name: "secondFloorM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Tipo de hotel",
          name: "hotelType",
          type: "sampleList",
          listName: "hotelType",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Categoría",
          name: "category",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          min: 0,
          languageSensitive: false,
        },
        {
          label: "Número de habitaciones",
          name: "roomsNumber",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          min: 0,
          languageSensitive: false,
        },
        {
          label: "Altura Libre",
          name: "freeHeight",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Campa",
          name: "campa",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Número de muelles",
          name: "piers",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          min: 0,
          languageSensitive: false,
        },
        {
          label: "Número de portones",
          name: "gates",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          min: 0,
          languageSensitive: false,
        },
        {
          label: "Parking",
          name: "hasParking",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Restaurante",
          name: "hasRestaurant",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Salida de humos",
          name: "hasSmokeOutlet",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Piscina",
          name: "hasSwimmingPool",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Falso techo",
          name: "hasFalseCeiling",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Falso piso",
          name: "hasFalseFloor",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Número de plazas de parking",
          name: "parkingPlacesAmount",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          min: 0,
          languageSensitive: false,
        },
        {
          label: "m² útiles",
          name: "usefulM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² brutos alquilables",
          name: "grossLeasableM2",
          type: "number",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          min: 0,
          languageSensitive: false,
        },
        {
          label: "Estado del activo",
          name: "assetStatus",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Estado ocupacional",
          name: "occupationalStatus",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
      ],
    },
    {
      label: "Suelo",
      id: "suelo",
      collapsable: true,
      metadata: [
        {
          label: "Id de SIGI",
          name: "sigiFloorId",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Estado SIGI",
          name: "sigiStatus",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Comercializable SIGI",
          name: "sigiMarketable",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² Brutos",
          name: "grossM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² Netos",
          name: "betsM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² Edificables sobre rasante",
          name: "buildingAboveGroundM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² Residencial - Libre",
          name: "freeResidentialM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² Residencial - Protegido",
          name: "protectedResidentialM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Número de viviendas",
          name: "households",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          min: 0,
          languageSensitive: false,
        },
        {
          label: "Número de viviendas libres",
          name: "freeHouseholds",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          min: 0,
          languageSensitive: false,
        },
        {
          label: "Número de viviendas de protección",
          name: "protectedFreeHouseholds",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          min: 0,
          languageSensitive: false,
        },
        {
          label: "m² Terciario",
          name: "terciaryM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² Comercial",
          name: "comercialM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² Industrial",
          name: "industrialM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² Hoteleros",
          name: "hoteliersM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "m² Otros",
          name: "othersM2",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Porcentaje de obra parada",
          name: "wipPercentage",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          addon: "%",
        },
        {
          label: "Ámbito",
          name: "scopePercent",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          addon: "%",
        },
        {
          label: "Titularidad",
          name: "ownershipPercent",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          addon: "%",
        },
        {
          label: "Perímetro Comercial",
          name: "commercialPerimeter",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Segmentación",
          name: "segmentation",
          type: "segmentation",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Superficie parcela",
          name: "plotArea",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Suelo técnico",
          name: "technicalFloor",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Tipología actividad",
          name: "activityType",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Volumen Edificable",
          name: "buildableVolume",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Nº de viviendas edificables",
          name: "buildableHomes",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Aprovechamiento",
          name: "exploitation",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Suministros",
          name: "supplies",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Edificaciones",
          name: "buildings",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Gestor urbanístico",
          name: "urbanManager",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          visibleFor: [PORTFOLIOS.QUASAR],
        },
      ],
    },
    {
      label: "Material gráfico",
      id: "graphicData",
      collapsable: true,
      metadata: [
        {
          label: "URL Youtube",
          name: "urlYoutube",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Video Cloud",
          name: "cloudVideo",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "URL TourVirtual",
          name: "urlVirtualTour",
          type: "textarea",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Plano",
          name: "hasPlans",
          type: "checkbox",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Decorview",
          name: "decorview",
          type: "checkbox",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Fotos Decorview",
          name: "decorviewImages",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,

          languageSensitive: false,
        },
        {
          label: "Número de Fotos",
          name: "numberOfPhotos",
          type: "number",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Letras de las fotos",
          name: "photoLetters",
          type: "textarea",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Fotos Plano",
          name: "schemeImages",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          // hidden: id ? hiddenFilter : hiddenTrue,
          languageSensitive: false,
        },
        {
          label: "Dossier",
          name: "urlDossier",
          type: "text",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Tipo tour virtual 3D",
          name: "typeVirtualTour3D",
          type: "list",
          typeList: "Normal",
          listName: "typeVirtualTour3DOptions",
          propertyId: "Id",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "URL tour virtual 3D",
          name: "urlVirtualTour3D",
          type: "textarea",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Mostrar en web",
          name: "targetWebsites",
          type: "list",
          typeList: "Normal",
          listName: "targetWebsitesOptions",
          propertyId: "id",
          propertyName: "name",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
      ],
    },
    {
      label: "Marketing",
      id: "marketing",
      collapsable: true,
      metadata: [
        {
          label: "Destacado Promoción",
          name: "isHighlighted",
          type: "checkbox",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Id Promoción Comercial",
          name: "commercialPromotionCode",
          type: "navigate",
          hidden: hiddenFilter,
          languageSensitive: false,
          showId: "commercialPromotionCode",
          navigateId: "commercialPromotionId",
        },
        {
          label: "Nombre Promoción Comercial",
          name: "commercialPromotionName",
          type: "text",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
      ],
    },
    {
      label: "Datos Pricing",
      id: "pricing",
      collapsable: true,
      metadata: [
        {
          label: "Importe valoración interna",
          name: "internalValuationAmount",
          type: "text",
          numberSeparator: true,
          addon: "€",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
          min: 0,
        },
        {
          label: "Fecha valoración interna",
          name: "internalValuationDate",
          type: "date",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Estado de Valoración",
          name: "valuationStatus",
          type: "sampleList",
          listName: "evaluationStatusOptions",
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Comentario Pricing",
          name: "pricingComment",
          type: "textarea",
          maxLength: 500,
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "BP",
          name: "bp",
          type: "text",
          maxLength: 50,
          disabled: disabledFalse,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
      ],
    },
    {
      label: "Auditoría",
      id: "audit",
      collapsable: true,
      metadata: [
        {
          label: "Fecha Creación",
          name: "creationTime",
          type: "dateText",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Usuario Creación",
          name: "creatorId",
          type: "textFromList",
          typeList: "Normal",
          listName: "userList",
          propertyList: "name",
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Fecha Última Modificación",
          name: "lastModificationTime",
          type: "dateText",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Usuario Modificación",
          name: "lastModifierId",
          type: "textFromList",
          typeList: "Normal",
          listName: "userList",
          propertyList: "name",
          hidden: hiddenFilter,
          languageSensitive: false,
        },
        {
          label: "Fecha Borrado",
          name: "deletionTime",
          type: "dateText",
          disabled: disabledTrue,
          hidden: hiddenFilter,
          languageSensitive: true,
        },
        {
          label: "Usuario Borrado",
          name: "deleterId",
          type: "textFromList",
          typeList: "Normal",
          listName: "userList",
          propertyList: "name",
          hidden: hiddenFilter,
          languageSensitive: false,
        },
      ],
    },
  ];
};
